import * as Yup from 'yup'

export const schemaResetPassword = Yup.object({
  first: Yup.string().required(''),
  second: Yup.string().required(''),
  third: Yup.string().required(''),
  fourth: Yup.string().required(''),
  fifth: Yup.string().required(''),
  sixth: Yup.string().required(''),
  password: Yup.string().required('Campo obrigatório.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), undefined], 'Senhas não são iguais')
    .required('Campo obrigatório.'),
})
